module.exports = __webpack_public_path__ + "img/menu-board-thai-express-2.59289c96.webp";